import EndPointConfig from '../../models/api/endPointConfig';

const controller = 'Products';

/// Define all EndPoints for Product section.
export const ProductsEP: EndPointConfig[] = [
    // Envio de formulario a la API
    new EndPointConfig().setMethod('GET').setController(controller).setAlias('GetProducts'),

    new EndPointConfig().setMethod('POST').setController(controller).setAlias('CreateProduct'),

    new EndPointConfig().setMethod('PATCH').setController(controller).setAlias('UpdateProduct'),

    new EndPointConfig()
        .setMethod('DELETE')
        .setController(controller)
        .setPattern('{id}')
        .setAlias('DeleteProduct'),
];
